import { useMutation, useQueryClient } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { ClaimService } from '@/api';

export const useSetClaimGroupIssueCommand = () => {
  const { pushErrors } = useToasts();
  const queryClient = useQueryClient();

  const {
    mutateAsync: handleSetClaimGroupIssueCommand,
    isLoading: isSetClaimGroupIssueCommandLoading,
  } = useMutation(
    ['setClaimGroupIssueCommand'],
    async ({
      claimGroupId,
      issueId,
    }: {
      claimGroupId: string;
      issueId: string;
    }) => {
      const response = await ClaimService.setClaimGroupIssueCommand({
        claimGroupId,
        issueId,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      await queryClient.invalidateQueries(['getClaimReasonsByIssueQuery']);

      return response.value;
    },
  );

  return {
    handleSetClaimGroupIssueCommand,
    isSetClaimGroupIssueCommandLoading,
  };
};
